import { render, staticRenderFns } from "./SectionTable.vue?vue&type=template&id=7b8ac8ff&scoped=true&"
import script from "./SectionTable.vue?vue&type=script&lang=js&"
export * from "./SectionTable.vue?vue&type=script&lang=js&"
import style0 from "./SectionTable.vue?vue&type=style&index=0&id=7b8ac8ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8ac8ff",
  null
  
)

export default component.exports